import React from 'react';
import MessengerWindow from './messenger_window';
import useWindowDimensions from '../../shared/hooks/use_window_dimensions';

const XS_BREAKPOINT = 480;

const Messenger = ({ creator }) => {
  const { width } = useWindowDimensions();

  const handleLoadMessenger =
    width >= XS_BREAKPOINT ? <MessengerWindow creator={creator} /> : null;

  return handleLoadMessenger;
};

export default Messenger;
